import type React from 'react';

import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();

	return (
		<>
			<PageBanner />
			<div className="container px-2 pt-4 pb-8">
				<PageBody />
			</div>
		</>
	);
};
